export const SegmentServiceModule = angular
    .module('app.services.tracking.segment.segment', [])
    .service('segmentService', ($window) => {
        let service = {
            trackGtmEvent,
            trackPage,
            trackIdentity
        };

        function trackPage(pageName, data) {
            return $window.analytics.page(pageName, data);
        }

        function trackIdentity(userId, data) {
            return $window.analytics.identify(userId, data);
        }

        function trackGtmEvent(attrs, options) {
            logGtmEvent(attrs, options);
        }

        function logGtmEvent(attrs, options) {
            if (typeof $window.dataLayer !== 'undefined') {
                let eventData = { event: attrs.analyticsClickEvent };

                if (Object.keys(options).length) {
                    eventData = Object.assign(eventData, options);
                }
                $window.dataLayer.push(eventData);
            }
        }

        return service;
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/tracking/segment/segment.service.js